export default {
  chats: [],
  participants: [],
  forwardContent: null,
  copiedMessage: null,
  messageReplied: false
};
